module.exports = __webpack_public_path__ + "static/emp_handbook-d0280d1d9dad3c6ca46eedaf757d2dbd.png";